import { useEffect, useState } from 'react';
import { Table, InputNumber, Button, Switch, Typography, Space, Tag, Statistic, Row, Col, message } from 'antd';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';
import api from '../../api/axios';
import './admin.css';

const { Text } = Typography;

export default function TariffsPage() {
    const [tariffs, setTariffs] = useState([]);
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [editValues, setEditValues] = useState({});

    const loadTariffs = () => {
        setLoading(true);
        api.get('/tariffs').then(res => {
            setTariffs(res.data.data || []);
        }).catch(err => console.error(err)).finally(() => setLoading(false));
    };

    const loadStats = () => {
        api.get('/tariffs/admin/stats').then(res => {
            setStats(res.data.data || null);
        }).catch(() => {});
    };

    useEffect(() => {
        loadTariffs();
        loadStats();
    }, []);

    const startEdit = (record) => {
        setEditingId(record.id);
        setEditValues({
            price_monthly: record.price_monthly,
            trial_days: record.trial_days,
            active: record.active,
        });
    };

    const cancelEdit = () => {
        setEditingId(null);
        setEditValues({});
    };

    const saveEdit = (id) => {
        api.put(`/tariffs/${id}`, editValues).then(() => {
            message.success('Tarif yangilandi');
            setEditingId(null);
            loadTariffs();
        }).catch(err => {
            message.error('Xatolik');
            console.error(err);
        });
    };

    const columns = [
        {
            title: 'Xizmat turi', dataIndex: 'service_type_name', key: 'type',
            render: (v) => <Text strong>{v}</Text>,
        },
        {
            title: 'Oylik narx (so\'m)', dataIndex: 'price_monthly', key: 'price', width: 200,
            render: (v, rec) => editingId === rec.id ? (
                <InputNumber
                    value={editValues.price_monthly}
                    onChange={val => setEditValues(p => ({ ...p, price_monthly: val }))}
                    min={0} style={{ width: '100%' }}
                    formatter={val => `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                    parser={val => val.replace(/\s/g, '')}
                />
            ) : (
                <Text strong style={{ color: '#1890ff' }}>{Number(v).toLocaleString()} so'm</Text>
            ),
        },
        {
            title: 'Sinov muddati (kun)', dataIndex: 'trial_days', key: 'trial', width: 170,
            render: (v, rec) => editingId === rec.id ? (
                <InputNumber
                    value={editValues.trial_days}
                    onChange={val => setEditValues(p => ({ ...p, trial_days: val }))}
                    min={0} max={365} style={{ width: '100%' }}
                />
            ) : (
                <Tag color="green">{v} kun</Tag>
            ),
        },
        {
            title: 'Holat', dataIndex: 'active', key: 'active', width: 100,
            render: (v, rec) => editingId === rec.id ? (
                <Switch
                    checked={!!editValues.active}
                    onChange={val => setEditValues(p => ({ ...p, active: val ? 1 : 0 }))}
                    checkedChildren="Aktiv"
                    unCheckedChildren="O'chiq"
                />
            ) : (
                v ? <Tag color="green">Aktiv</Tag> : <Tag color="red">O'chiq</Tag>
            ),
        },
        {
            title: '', key: 'actions', width: 160,
            render: (_, rec) => editingId === rec.id ? (
                <Space>
                    <Button type="primary" size="small" icon={<SaveOutlined />} onClick={() => saveEdit(rec.id)}>Saqlash</Button>
                    <Button size="small" onClick={cancelEdit}>Bekor</Button>
                </Space>
            ) : (
                <Button size="small" onClick={() => startEdit(rec)}>Tahrirlash</Button>
            ),
        },
    ];

    return (
        <div>
            {stats && (
                <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                    <Col xs={12} md={6}>
                        <div className="admin-panel"><Statistic title="Jami bizneslar" value={stats.total_businesses} /></div>
                    </Col>
                    <Col xs={12} md={6}>
                        <div className="admin-panel"><Statistic title="Jami xizmatlar" value={stats.total_services} /></div>
                    </Col>
                    <Col xs={12} md={6}>
                        <div className="admin-panel"><Statistic title="Aktiv to'lovlar" value={stats.active_payments || 0} /></div>
                    </Col>
                    <Col xs={12} md={6}>
                        <div className="admin-panel"><Statistic title="Jami daromad" value={Number(stats.total_revenue || 0).toLocaleString()} suffix="so'm" /></div>
                    </Col>
                </Row>
            )}

            <div className="admin-toolbar">
                <span style={{ color: 'var(--a-muted)', fontSize: 13 }}>Tariflar ro'yxati</span>
                <Button icon={<ReloadOutlined />} onClick={() => { loadTariffs(); loadStats(); }} style={{ marginLeft: 'auto' }}>Yangilash</Button>
            </div>

            <div className="admin-table-card">
                <Table
                    dataSource={tariffs}
                    columns={columns}
                    rowKey="id"
                    loading={loading}
                    pagination={false}
                    size="middle"
                    scroll={{ x: 700 }}
                />
            </div>
        </div>
    );
}
